import { Button, Card, Col, Collapse, Select } from 'antd';
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { SearchControl, ViewDocument as ViewDocumentControl } from '@seims/shared';
import service from '../../services/documentRepoService';
import { Divider } from 'antd';
import moment from 'moment';
import { DownloadOutlined } from '@ant-design/icons';

export default function ViewDocumentDetails() {

    const [documentDetails, setDocumentDetails] = useState([]);

    const mainTitle1 = "View Document";
    const { id } = useParams();
    const { Panel } = Collapse;
    const { Option } = Select;
    // const location = useLocation();
    let navigate = useNavigate();
    let path = `/document-repository/view`;


    useEffect(() => {
        prePopulate();
    }, [])

    const prePopulate = async () => {
        if (id) {
            const response = await service.getDocumentByType(id);
            setDocumentDetails(response);
        }
    };
    const handleInputChange = () => { };

    const onChange = (key) => {
    };

    const backToHome = () => {
        navigate(path);
    };

    return (
        <>
            <div className="content">
                <Col xs={24}>
                    <h1 className="center-align">{mainTitle1}</h1>
                </Col>
                <SearchControl handleInputChange={handleInputChange} />
                <Divider />
                <div style={{ overflow: "auto", height: "600px" }}>
                    {documentDetails.map(function (doc) {
                        return (
                            <>
                                <Card
                                    key={doc.id}
                                    title={
                                        <div style={{ display: "flex" }}>
                                            <div style={{ color: "#5DADE2" }}><b>{"Document Title: " + doc.title}</b></div>
                                            <div style={{ marginLeft: "auto", color: "#5DADE2" }}><b>{"Approval Date: " + moment(doc.approvalDate, "YYYY-MM-DD").format("DD MMM YYYY")}</b></div>
                                        </div>
                                    }
                                >
                                    {doc.description}
                                    <br /><br />
                                    {"Keywords: " + doc.keywords?.toString().replaceAll(',', ', ')}
                                    <Collapse defaultActiveKey={['1']} onChange={onChange}>

                                        <Panel
                                            key="2"
                                            header={
                                                <div style={{ display: "flex" }}>
                                                    <div style={{ color: "#5DADE2" }}><b>{"View more details"}</b></div>
                                                    <span style={{ marginLeft: "auto", color: "#5DADE2" }}>  <a target="_blank" aria-label="Document contents (new tab)"
                                                        href="https://html.spec.whatwg.org/print.pdf" rel="noreferrer"
                                                    >
                                                        <DownloadOutlined /> Download
                                                    </a></span>
                                                </div>
                                            }
                                        >
                                            <ViewDocumentControl data={doc} />
                                        </Panel>
                                    </Collapse>
                                </Card>
                                <Divider />
                            </>
                        )
                    })}
                    <Button
                        key="3b"
                        type="defaut"
                        // htmlType="submit"
                        className="right-align-button"
                        style={{ }}
                        onClick={()=>backToHome()}
                    >
                        Back
                    </Button>
                </div>
            </div>
        </>
    )
}
